<panel width="auto">
  <section one-column>
    <icon type="circle-user" />
    <text-group>
      <h3>{{ contact.fullName }}</h3>
      <div>{{ contact.role }}</div>
      @if (showEmail) {
        <a class="mailto field-mini" href="mailto:{{ contact.emailAddress }}">{{ contact.emailAddress }}</a>
      }
      @if (showPhone) {
        @for (phone of contact.contactPhones; track phone) {
          <div [hidden]="!phone.number">
            <a class="tel" href="tel:{{ phone.number }}"> {{ phone.number | phoneNumber }} </a>
          </div>
        }
      }
    </text-group>
  </section>
</panel>
